import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import validate from './validate';
import { renderField } from '../../../utils/renderFields';
import { fetchForgotPassword } from '../../../actions/auth';

const propTypes = {
  removeModal: PropTypes.func,
}

const defaultProps = {
  removeModal: function(){},
}

class ForgotPasswordForm extends React.Component {

  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  submit(values) {
    return this.props.dispatch(fetchForgotPassword(values, this.props.removeModal));
  }

  render(){
    const { error, handleSubmit, submitting, submitSucceeded } = this.props;
    if(submitSucceeded)
      return (
        <p>We've e-mailed you instructions for setting your password to the e-mail address you submitted. You should be receiving it shortly.</p>
      );
    return(
      <div className="p-20">
        <p>Forgotten your password? Enter your e-mail address below, and we'll e-mail instructions for setting a new one.</p>

        <form onSubmit={handleSubmit(this.submit)}>
          <span className={error ? 'has-danger' : ''}>
            <span className="u-fontSize-11 form-control-feedback">{error}</span>
          </span>
          <Field component={renderField} name="email" type="email" label="email" className="form-control" hiddenLabel />
          <input type="submit" value="Submit" id="submit" className="btn btn-primary" disabled={submitting} />
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    removeModal: ownProps.removeModal,
  }
}

ForgotPasswordForm = reduxForm({form:'forgot-password', validate, fields:['email','password','remember_me']})(ForgotPasswordForm);

ForgotPasswordForm.propTypes = propTypes;
ForgotPasswordForm.defaultProps = defaultProps;

export default connect(mapStateToProps)(ForgotPasswordForm);
